"use client";

import {Authenticator} from '@aws-amplify/ui-react';
import {Amplify} from 'aws-amplify';
import {
    createContext,
    Dispatch,
    SetStateAction,
    useContext,
    useState,
} from "react";
import {UserAttributes} from './service';

Amplify.configure({
    Auth: {
        Cognito: {
            loginWith: {
                email: true,
                oauth: {
                    domain: process.env.NEXT_PUBLIC_COGNITO_DOMAIN!,
                    scopes: ['email', 'profile', 'openid'],
                    responseType: 'code',
                    redirectSignIn: [
                        process.env.NEXT_PUBLIC_AUTH_REDIRECT!,
                        process.env.NEXT_PUBLIC_AUTH_REDIRECT_2!,
                    ],
                    redirectSignOut: [
                        process.env.NEXT_PUBLIC_AUTH_REDIRECT!,
                        process.env.NEXT_PUBLIC_AUTH_REDIRECT_2!,
                    ],
                },
            },
            userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID!,
            userPoolClientId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID!,
        }
    }
}, {ssr: true});

export const GlobalContext = createContext(
    {} as {
        userType: "viewer" | "commentator";
        setUserType: Dispatch<SetStateAction<"viewer" | "commentator">>;
        userData: UserAttributes | null;
        setUserData: Dispatch<SetStateAction<UserAttributes | null>>;
    },
);

export const GlobalProvider = ({children}: { children: React.ReactNode }) => {
    const [userType, setUserType] = useState<"viewer" | "commentator">("viewer");
    const [userData, setUserData] = useState<UserAttributes | null>(null);

    return (
        <GlobalContext.Provider value={{
            userType,
            setUserType,
            userData,
            setUserData
        }}>
            <Authenticator.Provider>
                {children}
            </Authenticator.Provider>
        </GlobalContext.Provider>
    );
};

export const useGlobalContext = () => {
    const context = useContext(GlobalContext);
    if (context === undefined) {
        throw new Error("useGlobalContext must be used within a GlobalProvider");
    }
    return context;
};
